/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Player_SigninInputs */

const th_player_signin = /** @type {(inputs: Player_SigninInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เข้าสู่ระบบเพื่อดูข้อมูลผู้เล่นรายนี้ ชื่อ โรงเรียน และโปรแกรมแข่งขันไม่เปิดเผยต่อสาธารณะ`)
};

const en_player_signin = /** @type {(inputs: Player_SigninInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign in to see this player. Their name, school and fixtures are not public.`)
};

const ja_player_signin = /** @type {(inputs: Player_SigninInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この選手を見るにはサインインしてください。氏名、学校、日程は公開されていません。`)
};

const zh_player_signin = /** @type {(inputs: Player_SigninInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`登录后可查看这名球员。他的姓名、学校和比赛并不公开。`)
};

const es_player_signin = /** @type {(inputs: Player_SigninInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inicia sesión para ver a este jugador. Su nombre, centro y partidos no son públicos.`)
};

const pt_player_signin = /** @type {(inputs: Player_SigninInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entre para ver este jogador. O nome, a escola e os jogos não são públicos.`)
};

const id_player_signin = /** @type {(inputs: Player_SigninInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masuk untuk melihat pemain ini. Nama, sekolah dan pertandingannya tidak publik.`)
};

const fr_player_signin = /** @type {(inputs: Player_SigninInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connectez-vous pour voir ce joueur. Son nom, son établissement et ses matchs ne sont pas publics.`)
};

const tl_player_signin = /** @type {(inputs: Player_SigninInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mag-sign in para makita ang manlalarong ito. Hindi pampubliko ang pangalan, paaralan at mga laro niya.`)
};

const vi_player_signin = /** @type {(inputs: Player_SigninInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đăng nhập để xem cầu thủ này. Tên, trường và các trận của họ không công khai.`)
};

const ko_player_signin = /** @type {(inputs: Player_SigninInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이 선수를 보려면 로그인하세요. 이름, 학교, 경기는 공개되지 않습니다.`)
};

const de_player_signin = /** @type {(inputs: Player_SigninInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Melde dich an, um diesen Spieler zu sehen. Name, Schule und Spiele sind nicht öffentlich.`)
};

const ru_player_signin = /** @type {(inputs: Player_SigninInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Войдите, чтобы увидеть этого игрока. Его имя, школа и матчи не общедоступны.`)
};

const tr_player_signin = /** @type {(inputs: Player_SigninInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bu oyuncuyu görmek için giriş yapın. Adı, okulu ve maçları herkese açık değil.`)
};

const it_player_signin = /** @type {(inputs: Player_SigninInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accedi per vedere questo giocatore. Nome, scuola e partite non sono pubblici.`)
};

const pl_player_signin = /** @type {(inputs: Player_SigninInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zaloguj się, aby zobaczyć tego zawodnika. Jego imię, szkoła i mecze nie są publiczne.`)
};

const uk_player_signin = /** @type {(inputs: Player_SigninInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Увійдіть, щоб побачити цього гравця. Його ім'я, школа та матчі не є загальнодоступними.`)
};

const hi_player_signin = /** @type {(inputs: Player_SigninInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इस खिलाड़ी को देखने के लिए साइन इन करें। उनका नाम, स्कूल और मैच सार्वजनिक नहीं हैं।`)
};

const ar_player_signin = /** @type {(inputs: Player_SigninInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سجّل الدخول لترى هذا اللاعب. اسمه ومدرسته ومبارياته ليست عامة.`)
};

const ms_player_signin = /** @type {(inputs: Player_SigninInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Log masuk untuk melihat pemain ini. Nama, sekolah dan perlawanannya tidak awam.`)
};

const bn_player_signin = /** @type {(inputs: Player_SigninInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`এই খেলোয়াড়কে দেখতে সাইন ইন করুন। তাঁর নাম, স্কুল ও খেলা প্রকাশ্য নয়।`)
};

const zh_tw2_player_signin = /** @type {(inputs: Player_SigninInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`登入後可查看這位球員。他的姓名、學校與比賽並不公開。`)
};

const zh_hk2_player_signin = /** @type {(inputs: Player_SigninInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`登入後可查看這位球員。他的姓名、學校與比賽並不公開。`)
};

const ur_player_signin = /** @type {(inputs: Player_SigninInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اس کھلاڑی کو دیکھنے کے لیے سائن اِن کریں۔ ان کا نام، اسکول اور میچ عوامی نہیں۔`)
};

const fa_player_signin = /** @type {(inputs: Player_SigninInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`برای دیدن این بازیکن وارد شوید. نام، مدرسه و بازی‌هایش عمومی نیست.`)
};

const sw_player_signin = /** @type {(inputs: Player_SigninInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingia ili kumwona mchezaji huyu. Jina lake, shule na michezo yake si ya wazi.`)
};

const nl_player_signin = /** @type {(inputs: Player_SigninInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Log in om deze speler te zien. Zijn naam, school en wedstrijden zijn niet openbaar.`)
};

/**
* | output |
* | --- |
* | "Sign in to see this player. Their name, school and fixtures are not public." |
*
* @param {Player_SigninInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const player_signin = /** @type {((inputs?: Player_SigninInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Player_SigninInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_player_signin(inputs)
	if (locale === "ja") return ja_player_signin(inputs)
	if (locale === "zh") return zh_player_signin(inputs)
	if (locale === "es") return es_player_signin(inputs)
	if (locale === "pt") return pt_player_signin(inputs)
	if (locale === "id") return id_player_signin(inputs)
	if (locale === "fr") return fr_player_signin(inputs)
	if (locale === "tl") return tl_player_signin(inputs)
	if (locale === "vi") return vi_player_signin(inputs)
	if (locale === "ko") return ko_player_signin(inputs)
	if (locale === "de") return de_player_signin(inputs)
	if (locale === "ru") return ru_player_signin(inputs)
	if (locale === "tr") return tr_player_signin(inputs)
	if (locale === "it") return it_player_signin(inputs)
	if (locale === "pl") return pl_player_signin(inputs)
	if (locale === "uk") return uk_player_signin(inputs)
	if (locale === "hi") return hi_player_signin(inputs)
	if (locale === "ar") return ar_player_signin(inputs)
	if (locale === "ms") return ms_player_signin(inputs)
	if (locale === "bn") return bn_player_signin(inputs)
	if (locale === "zh-TW") return zh_tw2_player_signin(inputs)
	if (locale === "zh-HK") return zh_hk2_player_signin(inputs)
	if (locale === "ur") return ur_player_signin(inputs)
	if (locale === "fa") return fa_player_signin(inputs)
	if (locale === "sw") return sw_player_signin(inputs)
	if (locale === "nl") return nl_player_signin(inputs)
	return en_player_signin(inputs)
});